import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { take } from 'rxjs/operators'
import { InformacoesInstitucionaisModel } from './../../models/backend'

@Injectable({
  providedIn: 'root',
})
export class InfosInstitucionaisService {
  constructor(private http: HttpClient) {}

  getInfosInstitucionais() {
    return this.http.get<InformacoesInstitucionaisModel>('/api/infosinstitucionais').pipe(take(1))
  }
}
